/**
 * @file: OrgUserRoleHelper.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { roleStringToUserRoles } from '@euler/functions/orgUserUtils';
import { OrgUserRoleType } from '@euler/model/enum';

export class OrgUserRoleHelper {
  private readonly roleSet: Set<string>;

  constructor(role: string | null | undefined) {
    this.roleSet = new Set(roleStringToUserRoles(role));
  }

  hasRole(role: OrgUserRoleType) {
    return this.roleSet.has(role);
  }

  hasAnyRole(...roles: OrgUserRoleType[]) {
    return roles.some(x => this.hasRole(x));
  }

  matchesAll(roles: OrgUserRoleType[]) {
    return this.roleSet.size > 0 && roles.every(x => this.roleSet.has(x));
  }

  matchesAny(roles: OrgUserRoleType[]) {
    return roles.some(x => this.hasRole(x));
  }
}
